<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>地图管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
    <!--  <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.deptName" placeholder="输入部门名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item> -->
      <el-form-item>

        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="dataList" highlight-current-row :header-cell-style="this.$store.state.headerCss" v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column  prop="provincecityName" label="地点" >
      </el-table-column>
      <el-table-column  prop="longitude" label="经度">
      </el-table-column>
      <el-table-column  prop="latitude" label="纬度">
      </el-table-column>
      <el-table-column  prop="userTotal" label="用户数量">
      </el-table-column>

      <el-table-column align="center" label="操作" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteInfo(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog" :close-on-click-modal="false">
      <el-form label-width="100px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="输入地名" prop="provincecityName">
        	<el-input size="small" v-model="editForm.provincecityName"></el-input>
        </el-form-item>
        <el-form-item label="输入经度" prop="longitude">
        	<el-input size="small" v-model="editForm.longitude"></el-input>
        </el-form-item>
        <el-form-item label="输入纬度" prop="latitude">
        	<el-input size="small" v-model="editForm.latitude"></el-input>
        </el-form-item>
        <el-form-item label="用户数量" prop="appId" style="width: 316px;">
          <el-input size="small" v-model="editForm.userTotal" auto-complete="off" placeholder="请输入用户数量"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAllProviceCity,addProvinceUserTotal,findProvinceUserTotalList,modifyProvinceUserTotal,removeProvinceUserTotal } from '../../api/summaryMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      proviceList:[],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        userTotal: '',
        provincecityName:"",
        longitude:"",
        latitude:""
      },
      dataList:[],
      // rules表单验证
      rules: {
        provincecityName: [
          { required: true, message: '请选择省份', trigger: 'blur' }
        ],

      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total:0
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    this.getData()
    this.getProviceCity()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    getData() {
      findProvinceUserTotalList(this.pageparm).then(res => {
        if(res.status == 1){
          this.dataList = res.data.data
          this.pageparm.total = res.data.totalCount
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    getProviceCity:function(){
    	getAllProviceCity().then(res => {
    		if(res.status == 1){
    			this.proviceList = res.data
    		}else{
    			this.$message.error(res.msg)
    		}
    	})
    },


    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
     console.log(this.pageparm)
      this.getData()

    },
    // 搜索事件
    search() {

    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.userTotal = row.userTotal
        this.editForm.provincecityName = row.provincecityName
        this.editForm.longitude = row.longitude
        this.editForm.latitude =row.latitude

      } else {
        this.title = '添加'
        this.editForm.id = ""
        this.editForm.userTotal = ''
        this.editForm.provincecityName = ""
        this.editForm.longitude = ""
        this.editForm.latitude = ""
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.title == '添加'){
            this.saveData()
          }else{
            this.upDateData()
          }

        } else {
          return false
        }
      })
    },
    saveData(){
      addProvinceUserTotal(this.editForm)
        .then(res => {
          this.loading = false
          this.editFormVisible = false

          if (res.status == 1) {
            this.$message({
              type: 'success',
              message: '添加成功！'
            })
            this.getData()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
    },

    upDateData(){
      modifyProvinceUserTotal(this.editForm)
        .then(res => {
          this.loading = false
          this.editFormVisible = false

          if (res.status == 1) {
            this.$message({
              type: 'success',
              message: '修改成功！'
            })
            this.getData()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
    },

    deleteInfo(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeProvinceUserTotal({userTotalId:row.id})
            .then(res => {
              if(res.status == 1){
                this.$message.success('删除成功')
                this.getData()
              }else{
                this.$message.error(res.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/MapSet.vue